import React from "react";

export default function BrandMark({ compact = false }) {
  return (
    <span className={`brand-lockup${compact ? " brand-lockup--compact" : ""}`} aria-label="Crovian">
      <svg className="brand-mark" viewBox="0 0 44 44" aria-hidden="true">
        <path
          d="M34.5 11.2A16 16 0 1 0 34.5 32.8"
          fill="none"
          stroke="currentColor"
          strokeWidth="7"
          strokeLinecap="square"
        />
        <rect x="34" y="18" width="5" height="5" fill="currentColor" />
        <rect x="37" y="26" width="3" height="3" fill="currentColor" opacity=".55" />
      </svg>
      <span className="brand-word">CROVIAN</span>
    </span>
  );
}
